import type { AppRouter } from '@glocal/api/src/server'

import { createTRPCProxyClient, httpBatchLink } from '@trpc/client'
import { getAuth } from 'firebase/auth'

import { firebaseApp } from './firebase'

export function trpc() {
	return createTRPCProxyClient<AppRouter>({
		links: [
			httpBatchLink({
				// Our own zone, not the worker's *.workers.dev address: some DNS filters
				// (AdGuard DNS) don't resolve workers.dev at all, and login hung behind them.
				url: 'https://api.nayda.pro/trpc',
				async headers() {
					const user = getAuth(firebaseApp).currentUser
					if (!user) {
						return {}
					}
					const token = await user.getIdToken()
					return { Authorization: `Bearer ${token}` }
				},
			}),
		],
	})
}
